var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/card-msg-ganji.html');
var utils = require('../../global/utils');

var CardMsgItem = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    BaseMsgItem.call(self, defaults);
  })(this);

  // 是否已经被render过
  this._rendered = false;
};
CardMsgItem.prototype = Object.create(BaseMsgItem.prototype);

CardMsgItem.prototype.renderContent = function () {
  var defHref = 'javascript:void(0)';
  var msg = this._data.msg;
  var content = msg.content;
  var header = content.card_header;
  var title = header.title;
  var subTitles = header.sub_titles.slice(0, 2);
  var list = content.card_content_array.slice(0, 2);

  var $element = this._element;
  var $header = $element.find('.card-header');
  var $title = $header.find('.card-title');
  var $sub = $header.find('.card-sub-titles');
  var $list = $element.find('.card-list');
  var $more = $element.find('.card-more');
  var tpl = $list.find('script').html();
  var $stub = $('<div>');

  $element.find('.im-msg-content').on('click', '[href]', function(e) {
    e.preventDefault();
    var url_jump = $(this).attr('href');
    if (url_jump != defHref) {
      utils.openPage(url_jump);
    }
  });

  $title.text(title);
  for (var i=0; i<subTitles.length; i++) {
    $sub.append($('<div class="one-line card-sub-title">').text(subTitles[i]));
  }

  if (content.card_list_url) {
    $more.attr({href: content.card_list_url || defHref});
  } else {
    $more.hide();
  }

  var len = list.length;
  for (var i=0; i<len; i++) {
    var cls = (i === len - 1) ? 'last-item' : '';
    var item = list[i];
    var labels = item.card_sub_labels;
    var hasLabel = labels && labels.length > 0;
    var hasImg = !!item.card_sub_picture_url;

    var $item = $(tpl).attr({
      href: item.card_sub_action_pc_url || defHref
    }).addClass(cls);

    var $label = $item.find('.item-label').html('');
    var $img = $item.find('.item-img');
    var $price = $item.find('.item-price');

    if (hasLabel) {
      for (var j=0; j<labels.length; j++) {
        $label.append($('<span class="label">').text(labels[j]));
      }
    } else {
      $label.remove();
    }

    if (item.card_sub_content) {
      $price.text(item.card_sub_content);
    } else {
      $price.remove();
    }

    $item.find('.item-title').attr({
      title: item.card_sub_title
    }).text(item.card_sub_title);

    if (hasImg) {
      $img.attr({
        src: item.card_sub_picture_url
      });
    } else {
      $item.addClass('no-img');
      $img.remove();
    }

    $stub.append($item);
  }

  $list.html($stub.html());
};

module.exports = CardMsgItem;